import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select } from '@mui/material';

export default function TimeNotation({ value, onChange }) {
  const timeFormat = ['am', 'pm'];
  return (
    <Select
      size="small"
      value={value}
      onChange={(v) => {
        onChange(v.target.value);
      }}
      sx={{
        textTransform: 'uppercase',
        '.MuiOutlinedInput-notchedOutline': {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        }
      }}
    >
      {timeFormat.map((t, index) => (
        <MenuItem key={index} value={t} sx={{ textTransform: 'uppercase' }}>
          {t}
        </MenuItem>
      ))}
    </Select>
  );
}

TimeNotation.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};
